<h1 mat-dialog-title class="title-custom" fxLayoutAlign="center center">
   {{data.title ? data.title :''}}
</h1>
<mat-progress-bar mode="query"></mat-progress-bar>

<div mat-dialog-content>
    <h4  fxLayoutAlign="center center"> {{data.message ? data.message : ''}} </h4>
    <div fxLayoutAlign="center center">
        <span><b [innerHTML]="data.name ? data.name : ''"></b></span>
    </div>
</div>
<br />
<div fxLayoutAlign="center center" mat-dialog-actions>
    <div fxLayout="row" fxLayoutAlign="space-around center" >
        <button mat-stroked-button color="warn" (click)="onCancel()">Cancelar</button>
        <button *ngIf="!data.noConfirm" mat-stroked-button color="success" (click)="onConfirm()"> {{ data.btnName ? data.btnName : 'Sí' }} </button>
    </div>
</div>